{
  "brand": "VBB PLAY",
  "tagline": "Premium oyun platformu",
  "loading": "Yükleniyor…",
  "retry": "Tekrar dene",
  "close": "Kapat",
  "search": "Ara",
  "seeAll": "Tümünü gör",
  "comingSoon": "Yakında",
  "currency": "AZN",
  "language": "Dil",
  "selectLanguage": "Dil seç",
  "offlineHint": "Bağlantı kontrol ediliyor",
  "footerRights": "© {{year}} VBB PLAY. Tüm hakları saklıdır.",
  "footerSupport": "Destek",
  "heroEyebrow": "SINIRLARIN ÖTESİNDE OYNA",
  "heroTitle": "Daha büyük oyunlar, daha cesur kazançlar",
  "heroSubtitle": "Sınırların ötesinde oyna — premium lobi, güvenli kasa ve seçilmiş oyunlar.",
  "heroCta": "Şimdi oyna",
  "promoFallbackTitle": "Hoş geldin bonusu",
  "promoFallbackSubtitle": "Bonus ve VIP programları hazırlanıyor. Kampanyalar açılınca teklifleri alın.",
  "promoFallbackCta": "Şimdi al",
  "promoFilter_all": "Tümü",
  "promoFilter_welcome": "Hoş geldin",
  "promoFilter_casino": "Casino",
  "promoFilter_sports": "Spor",
  "promoFilter_vip": "VIP",
  "login": "Giriş yap",
  "storyBonuses": "Bonuslar",
  "storyVip": "VIP Cashback",
  "storyCashback": "Cashback",
  "storyCrypto": "Kripto",
  "storyInvite": "Arkadaş daveti",
  "bonusSelectTitle": "Bonus seçin",
  "continue": "Devam",
  "supportWelcome": "VBB PLAY’e hoş geldiniz",
  "supportPrechat": "Başlamadan önce iletişim bilgilerinizi ve sorunuzu girin.",
  "supportEmail": "E-posta",
  "supportName": "Ad",
  "supportMessage": "Mesaj",
  "supportConsent": "Kişisel verilerin işlenmesini ve gizlilik politikasını kabul ediyorum.",
  "startDialogue": "Diyaloğu başlat",
  "attach": "Ekle",
  "send": "Gönder",
  "support247": "7/24 Destek",
  "supportInvite": "Operatörlerimiz yardımcı olmaya hazır.",
  "contactSupport": "Destekle iletişime geç",
  "infoSection": "Bilgi",
  "referral": "Referans",
  "liveSports": "Canlı",
  "prematch": "Maç öncesi",
  "fiatMethods": "Fiat",
  "fiatMethodsHint": "Kart, M10, Terminal",
  "cryptoMethodsHint": "Kasada desteklenen kripto yöntemleri",
  "personalInfo": "Kişisel bilgiler",
  "contactInfo": "İletişim bilgileri",
  "displayName": "Ad",
  "notAvailable": "Kullanılamıyor",
  "phone": "Telefon",
  "profileEditHint": "Ad, doğum tarihi ve cinsiyet hesabınızda saklanır.",
  "myProfile": "Profilim",
  "securitySettings": "Güvenlik",
  "rewardCenter": "Ödül merkezi",
  "notificationsTitle": "Bildirimler",
  "markAllRead": "Tümünü okundu işaretle",
  "marketingOptIn": "Promosyon bildirimlerini al",
  "emptyNotifications": "Bildirim yok",
  "notificationsUnavailable": "Olay bildirimleri oluştuğunda burada görünür. Uydurma içerik yok.",
  "open": "Aç",
  "protectionTitle": "Hesap koruması",
  "coolingOff": "Cooling-off başlat",
  "selfExclude": "Kendini hariç tut",
  "requestClosure": "Hesap kapatma talebi",
  "helpSupport": "Yardım ve destek",
  "promoCode": "Promosyon kodu",
  "redeem": "Kullan",
  "bonusHistory": "Bonus geçmişi",
  "promoLoginRequired": "Kod kullanmak için giriş yapın.",
  "promoSuccess": "{{amount}} AZN yatırıldı",
  "promo_invalid_code": "Bu kod geçerli değil.",
  "promo_campaign_expired": "Bu kampanya süresi dolmuş.",
  "promo_campaign_inactive": "Bu kampanya aktif değil.",
  "promo_campaign_not_started": "Bu kampanya henüz başlamadı.",
  "promo_per_user_limit": "Bu kodu zaten kullandınız.",
  "promo_unique_user_limit": "Bu kampanya oyuncu limitine ulaştı.",
  "promo_usage_limit": "Bu kampanya için kullanım hakkı kalmadı.",
  "promo_not_eligible": "Bu kampanyaya uygun değilsiniz.",
  "promo_minimum_deposit_not_satisfied": "Uygun bir yatırma gerekli.",
  "promo_budget_exhausted": "Bu kampanyanın bütçesi tükendi.",
  "promo_too_many_requests": "Çok fazla deneme. Daha sonra tekrar deneyin.",
  "promo_zero_reward": "Bu kampanyanın burada talep edilecek nakit ödülü yok.",
  "promo_redeem_failed": "Kod kullanılamadı.",
  "storyPromo": "Promosyon kodu",
  "liveSupport": "Canlı destek",
  "sportsUnavailable": "Canlı spor bahisleri henüz yok. Casino oyunları açık.",
  "linked": "Bağlı",
  "notLinked": "Bağlı değil",
  "loadFailed": "Yüklenemedi",
  "unavailableTitle": "Kullanılamıyor",
  "vipUnavailable": "VIP seviyeleri henüz yapılandırılmadı.",
  "givenName": "Ad",
  "familyName": "Soyad",
  "dateOfBirth": "Doğum tarihi",
  "gender": "Cinsiyet",
  "genderMale": "Erkek",
  "genderFemale": "Kadın",
  "genderOther": "Diğer",
  "genderPreferNot": "Belirtmek istemiyorum",
  "saveProfile": "Profili kaydet",
  "profileSaved": "Profil kaydedildi",
  "profileSaveFailed": "Profil kaydedilemedi",
  "identityLockedNotice": "Kişisel bilgileriniz kayıtlı. Değişiklik için canlı destekle iletişime geçin.",
  "identityChangeRequest": "Değişiklik talep et",
  "identityChangeReason": "Değişiklik nedeni",
  "identitySubmitRequest": "Talebi gönder",
  "identityChangePending": "Talebiniz inceleniyor.",
  "identityChangeSubmitted": "Talep gönderildi. Canlı destek dönüş yapacak.",
  "identityChangeFailed": "Talep gönderilemedi.",
  "identityNoChanges": "Talep edilecek değişiklik yok.",
  "createdAt": "Hesap oluşturulma",
  "ageIneligible": "Bu doğum tarihi yasal yaşın altında. Gerçek parayla oyun kapalı kalır.",
  "rateOperator": "Bu görüşmeyi puanla",
  "ratingComment": "İsteğe bağlı geri bildirim",
  "submitRating": "Puanı gönder",
  "ratingThanks": "Puanınız için teşekkürler",
  "footerRules": "Kurallar",
  "footerPrivacy": "Gizlilik",
  "rulesLink": "Kurallar ve politikalar",
  "footerLegalTitle": "Yasal bilgi",
  "footerLegalDraftBadge": "TASLAK",
  "footerLegalDraftNotice": "Aşağıdaki bilgiler yalnızca yerel bir yasal taslaktır. Şirket kaydı ve lisans onaylanana kadar doğrulanmış oldukları, VBB PLAY’in lisanslı olduğu veya tüm şans oyunu faaliyetlerini yasal yürütme yetkisine sahip olduğu iddia edilmez.",
  "footerCompanyLabel": "Şirket",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Kayıt ülkesi",
  "footerCountryValue": "Kosta Rika",
  "footerRegNumberLabel": "Kayıt numarası",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Kayıtlı adres",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, 200 metres south of the Multiplaza de Escazu cinemas, Seiba Street, Centro Corporativo EBC, tenth floor, Invicta Legal office.",
  "footerLicenseNumberLabel": "Sunulan lisans numarası",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Sunulan lisans yargı alanı",
  "footerLicenseJurisdictionValue": "Anjouan, Union of the Comoros",
  "footerLegalAria": "Yasal bilgi",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com, Kosta Rika’da tescilli Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirketine aittir ve bu şirket tarafından yönetilmektedir; tescil numarası 2-101-918934, yasal adresi: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu sinemalarından 200 metre güneyde, Seiba Caddesi, Centro Corporativo EBC, onuncu kat, Invicta Legal ofisi. vbbplay.com, Komorlar Birliği Özerk Anjuan Adası Hükümeti tarafından lisanslanmış ve düzenlenmiştir ve ALSI-207508070-FI1 numaralı lisans kapsamında faaliyet göstermektedir. VbbPlay.com tüm düzenleyici gereklilikleri karşılamıştır ve her türlü şans oyunu ile bahis işlemlerini yasal olarak yürütmeye yetkilidir.",
  "back": "Geri",
  "rulesSelectAria": "Yasal belge seçin",
  "scrollToTop": "Yukarı çık",
  "footerAria": "Site altbilgisi",
  "footerLiveCasino": "Canlı casino",
  "footerProviders": "Sağlayıcılar",
  "footerFastGames": "Hızlı oyunlar",
  "footerEsports": "E-spor",
  "footerTournaments": "Turnuvalar",
  "footerPartnership": "Ortaklık programı",
  "footerTechSupport": "Teknik destek",
  "footerSupportSecurity": "Destek ve güvenlik",
  "footerSocial": "Sosyal ağlar",
  "footerSocialPending": "Resmi sosyal hesaplar onaylandıktan sonra burada görünecek.",
  "footerAgeHint": "Yalnızca 18+",
  "footerLegalAccordionTitle": "Yasal bilgi"
}
